import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  MobileStepper,
  Typography,
  IconButton,
  Button,
} from "@mui/material";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";

const EfficacyInstructions = ({ open, onClose, imagePaths }) => {
  const { t } = useTranslation();
  const [activeStep, setActiveStep] = useState(0);
  const steps = imagePaths;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const dialogStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backdropFilter: "blur(5px)",
  };

  // const contentStyle = {
  //   textAlign: "center",
  //   position: "relative",
  // };

  const closeButtonStyle = {
    position: "absolute",
    top: 0,
    right: 0,
    margin: "16px", // Add margin as needed
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      style={dialogStyle}
      maxWidth="md"
      fullWidth={true}
    >
      {/* Close button */}
      <IconButton
        edge="end"
        color="inherit"
        onClick={onClose}
        style={closeButtonStyle}
        aria-label="close"
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        {/* Display current step */}
        <Typography variant="h5" gutterBottom fontWeight={700}>
          {activeStep + 1}
        </Typography>

        {/* Display current image */}
        <img
          src={imagePaths[activeStep]}
          alt={`help-img-${activeStep + 1}`}
          style={{ display: "block", margin: "auto", maxWidth: "100%" }}
        />

        {/* Mobile Stepper */}
        <MobileStepper
          variant="dots"
          steps={steps.length}
          position="static"
          activeStep={activeStep}
          nextButton={
            <Button
              size="small"
              onClick={handleNext}
              disabled={activeStep === steps.length - 1}
            >
              {t("dashboard.helpInstructions.nextBtn")}
              <KeyboardArrowRight />
            </Button>
          }
          backButton={
            <Button
              size="small"
              onClick={handleBack}
              disabled={activeStep === 0}
            >
              <KeyboardArrowLeft />
              {t("dashboard.helpInstructions.prevBtn")}
            </Button>
          }
        />
      </DialogContent>
    </Dialog>
  );
};

export default EfficacyInstructions;
